import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import Socials from "./socials"
import HamburgerMenu from "react-hamburger-menu"
import Menu from "./menu"

const HeaderContainer = styled.header`
  width: 100%;
  padding: 3% 5%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: 0.2s ease;
  background-color: ${props => (props.isScrolled ? "black" : "none")};
  display: ${props => props.hideNav && "none"};
`
const Title = styled.h1`
  font-family: "alternategothic2_btregular";
  color: white;
  text-transform: uppercase;
  margin: 0;
`
const Logo = styled.img`
  margin: 0;
  width: 160px;
`
const Right = styled.div`
  display: flex;
  flex-direction: row;
  z-index: 100;
  cursor: pointer;
`

class Header extends React.Component {
  state = {
    isOpen: false,
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", this.handleScroll)
    }
  }

  handleScroll = event => {
    const scrollTop = window.pageYOffset
    const { stuck } = this.state
    // console.log(scrollTop)

    if (scrollTop > 65) {
      if (stuck) {
        //Do NOthing, return
        return
      }
      this.setState({ isScrolled: true, stuck: true })
      // this.props.handleSticky(true)
    } else {
      this.setState({ isScrolled: false, stuck: false })
      // this.props.handleSticky(false)
    }
  }

  render() {
    return (
      <HeaderContainer
        hideNav={this.props.hideNav}
        isScrolled={this.state.isScrolled}
      >
        <Logo src={require("../images/T&T Rocks logo_white.svg")} />
        <Right>
          <HamburgerMenu
            isOpen={this.state.isOpen}
            menuClicked={() => this.setState({ isOpen: !this.state.isOpen })}
            width={40}
            height={20}
            strokeWidth={2}
            rotate={0}
            color="white"
            borderRadius={0}
            animationDuration={0.5}
          />
          <Menu isOpen={this.state.isOpen} />
        </Right>
      </HeaderContainer>
    )
  }
}

export default Header
